// ✅ src/App.js (FULL) — Withdraw now opens normally (POPUP ONLY, NO REDIRECT BOOTSTRAP)

import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import "./App.css";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./lib/firebase";

import LandingScreen from "./screens/LandingScreen";
import LoginPage from "./pages/LoginPage";
import TermsScreen from "./pages/TermsScreen";
import PrivacyScreen from "./pages/PrivacyScreen";
import CommunityGuidelines from "./pages/CommunityGuidelines";

import DatingProfileCreationScreen from "./components/DatingProfileCreationScreen";

import ChatsScreen from "./screens/ChatsScreen";
import ChatScreen from "./screens/ChatScreen";
import UpgradeScreen from "./screens/UpgradeScreen";
import EditProfileScreen from "./screens/EditProfileScreen";
import ProfileDetailsScreen from "./components/ProfileDetailsScreen";
import MeetupsScreen from "./screens/MeetupsScreen";

import HomeScreen from "./screens/HomeScreen";
import LikesScreen from "./screens/LikesScreen";
import MatchesScreen from "./screens/MatchesScreen";
import SettingsScreen from "./screens/SettingsScreen";

import BuyGiftsScreen from "./screens/BuyGiftsScreen";
import WithdrawScreen from "./screens/WithdrawScreen";

import LeaderboardScreen from "./screens/LeaderboardScreen";

import AdminScreen from "./screens/AdminScreen";
import ContactUsScreen from "./screens/ContactUsScreen";
import ReportScreen from "./screens/ReportScreen";

import AppLayout from "./components/AppLayout";
import CallScreen from "./screens/CallScreen";
import PublicProfileScreen from "./screens/PublicProfileScreen";
import DownloadAppScreen from "./screens/DownloadAppScreen";
import NotificationsScreen from "./screens/NotificationsScreen";
import AdminSeedGiftFields from "./screens/AdminSeedGiftFields";

import IncomingCallListener from "./components/IncomingCallListener";

const ADMIN_EMAIL = "k16278422@gmail.com";

/* ---------------- AdminOnly wrapper ---------------- */
function AdminOnly({ children }) {
  const [ok, setOk] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      const email = String(u?.email || "").toLowerCase();
      setOk(email === ADMIN_EMAIL);
    });
    return () => unsub();
  }, []);

  if (ok === null) return null;
  return ok ? children : <Navigate to="/home" replace />;
}

/* ---------------- Login wrapper ---------------- */
function LoginRouteWrapper() {
  const nav = useNavigate();
  return (
    <LoginPage
      goBack={() => nav(-1)}
      onSuccess={() => nav("/create-profile", { replace: true })}
    />
  );
}

/* ---------------- App ---------------- */
export default function App() {
  return (
    <BrowserRouter>
      <IncomingCallListener />

      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingScreen />} />
        <Route path="/login" element={<LoginRouteWrapper />} />
        <Route path="/terms" element={<TermsScreen />} />
        <Route path="/privacy" element={<PrivacyScreen />} />
        <Route path="/guidelines" element={<CommunityGuidelines />} />

        <Route
          path="/create-profile"
          element={<DatingProfileCreationScreen mode="create" />}
        />

        {/* App Layout */}
        <Route element={<AppLayout />}>
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/likes" element={<LikesScreen />} />
          <Route path="/matches" element={<MatchesScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />

          <Route path="/notifications" element={<NotificationsScreen />} />
          <Route path="/download-app" element={<DownloadAppScreen />} />
          <Route path="/public-profile/:uid" element={<PublicProfileScreen />} />
          <Route path="/leaderboard" element={<LeaderboardScreen />} />

          <Route path="/buy-gifts" element={<BuyGiftsScreen />} />

          {/* ✅ Withdraw now normal (no Admin lock) */}
          <Route path="/withdraw" element={<WithdrawScreen />} />

          {/* Seed Gift Fields still admin locked */}
          <Route
            path="/seed-gifts"
            element={
              <AdminOnly>
                <AdminSeedGiftFields />
              </AdminOnly>
            }
          />

          <Route path="/profile-details" element={<ProfileDetailsScreen />} />
          <Route path="/edit-profile" element={<EditProfileScreen />} />

          <Route path="/chats" element={<ChatsScreen />} />
          <Route path="/chat/:matchId" element={<ChatScreen />} />

          <Route path="/report/:matchId" element={<ReportScreen />} />
          <Route path="/call/:matchId" element={<CallScreen />} />

          <Route path="/meetups" element={<MeetupsScreen />} />
          <Route path="/upgrade" element={<UpgradeScreen />} />

          <Route path="/contact" element={<ContactUsScreen />} />
          <Route path="/admin" element={<AdminScreen />} />

          <Route path="/profile" element={<Navigate to="/home" replace />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}